import React from 'react';
import { type PricingPageHeaderCard } from '@bbkAdminRedux/rtkq/experience.slice';
import RenderAlignedHtml from '@bbkPricingPage/components/card/components/aligned-html-render';

const PricingPageHeader: React.FC<{
  card: PricingPageHeaderCard;
}> = ({ card }) => {
  const heading = card?.requires.header?.title ?? '';
  const subHeading = card?.requires.header?.details ?? '';

  return (
    <div
      className="tw-w-full !tw-bg-[var(--pricing-page-background-color)] tw-@container"
      style={{ fontFamily: 'var(--pricing-page-font-family)' }}
    >
      <div className="tw-flex tw-w-full tw-flex-col tw-items-center tw-px-4 tw-pt-4 @sm:tw-pt-6 @md:tw-pt-12">
        <div className="tw-max-w-full">
          <div
            id="pricing-page-header"
            className="tw-my-2 tw-text-balance tw-text-center tw-font-bold tw-tracking-tight !tw-text-[var(--pricing-page-headline-color)]"
          >
            <RenderAlignedHtml
              value={heading}
              centerImages
              className="!tw-text-inherit !tw-text-3xl @sm:!tw-text-4xl [&_.slate-p]:tw-leading-10"
            />
          </div>
          <div
            id="pricing-page-subheader"
            className="tw-my-2 tw-text-balance tw-text-center !tw-text-[color-mix(in_srgb,var(--pricing-page-headline-color)_60%,transparent)]"
          >
            <RenderAlignedHtml
              value={subHeading}
              centerImages
              className={
                '!tw-text-inherit @sm:!tw-text-xl [&_.slate-p]:tw-leading-6 ' +
                '[&_.slate-ol]:tw-mx-auto [&_.slate-ul]:tw-mx-auto ' +
                '[&_.slate-ol]:tw-w-max [&_.slate-ul]:tw-w-max ' +
                '[&_.slate-ol]:tw-text-left [&_.slate-ul]:tw-text-left ' +
                '[&_.slate-ol]:!tw-pl-6 [&_.slate-ul]:!tw-pl-6'
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PricingPageHeader;
